var _defs, _rect, _text, _text2, _rect2, _rect3, _rect4, _g, _g2, _circle, _circle2, _rect5, _text3, _circle3, _text4, _text5, _text6, _g3, _rect6, _circle4, _path, _text7, _text8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzMatchDashboardDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 650,
    viewBox: "0 0 900 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz opportunity-match dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lensStroke",
    x1: 438,
    y1: 102,
    x2: 777,
    y2: 463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#54CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lensGlow",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(637 278) rotate(90) scale(157)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCEEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "topRow",
    x1: 40,
    y1: 146,
    x2: 330,
    y2: 225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF6FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-12%",
    y: "-12%",
    width: "124%",
    height: "132%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 14,
    stdDeviation: 18,
    floodColor: "#236DC2",
    floodOpacity: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 898,
    height: 648,
    rx: 24,
    fill: "#FFFFFF",
    fillOpacity: 0.94,
    stroke: "#D9E4F3",
    strokeWidth: 2,
    filter: "url(#shadow)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 62,
    fill: "#07172F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 31,
    fontWeight: 750
  }, "Opportunity match")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 91,
    fill: "#62728D",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16
  }, "Ranked. Explained. Interview-ready.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 126,
    width: 322,
    height: 414,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#D9E4F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 126.5,
    width: 321,
    height: 81,
    rx: 15.5,
    fill: "url(#topRow)",
    stroke: "#087CFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 143,
    width: 4,
    height: 49,
    rx: 2,
    fill: "#087CFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 177,
    fill: "#07172F",
    fontSize: 18,
    fontWeight: 700
  }, "1"), /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 167,
    r: 25,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 103,
    y: 174,
    fill: "#FFFFFF",
    fontSize: 16,
    textAnchor: "middle",
    fontWeight: 700
  }, "AB"), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 153,
    width: 102,
    height: 9,
    rx: 4.5,
    fill: "#5B9EF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 171,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#C4D9F5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 322,
    y: 176,
    fill: "#087CFF",
    fontSize: 24,
    textAnchor: "end",
    fontWeight: 750
  }, "92%"), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 207,
    x2: 332,
    y2: 207,
    stroke: "#E2EAF5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 252,
    fill: "#07172F",
    fontSize: 17,
    fontWeight: 650
  }, "2"), /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 241,
    r: 22,
    fill: "#DCE5F2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 103,
    y: 247,
    fill: "#24344D",
    fontSize: 15,
    textAnchor: "middle",
    fontWeight: 700
  }, "CD"), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 229,
    width: 100,
    height: 8,
    rx: 4,
    fill: "#C9D5E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 246,
    width: 60,
    height: 7,
    rx: 3.5,
    fill: "#DEE6F1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 322,
    y: 248,
    fill: "#07172F",
    fontSize: 20,
    textAnchor: "end",
    fontWeight: 700
  }, "78%"), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 279,
    x2: 332,
    y2: 279,
    stroke: "#E2EAF5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 324,
    fill: "#07172F",
    fontSize: 17,
    fontWeight: 650
  }, "3"), /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 313,
    r: 22,
    fill: "#DCE5F2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 103,
    y: 319,
    fill: "#24344D",
    fontSize: 15,
    textAnchor: "middle",
    fontWeight: 700
  }, "EF"), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 301,
    width: 90,
    height: 8,
    rx: 4,
    fill: "#C9D5E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 318,
    width: 51,
    height: 7,
    rx: 3.5,
    fill: "#DEE6F1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 322,
    y: 320,
    fill: "#07172F",
    fontSize: 20,
    textAnchor: "end",
    fontWeight: 700
  }, "71%"), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 351,
    x2: 332,
    y2: 351,
    stroke: "#E2EAF5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 396,
    fill: "#07172F",
    fontSize: 17,
    fontWeight: 650
  }, "4"), /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 385,
    r: 22,
    fill: "#DCE5F2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 103,
    y: 391,
    fill: "#24344D",
    fontSize: 15,
    textAnchor: "middle",
    fontWeight: 700
  }, "GH"), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 373,
    width: 82,
    height: 8,
    rx: 4,
    fill: "#C9D5E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 390,
    width: 45,
    height: 7,
    rx: 3.5,
    fill: "#DEE6F1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 322,
    y: 392,
    fill: "#07172F",
    fontSize: 20,
    textAnchor: "end",
    fontWeight: 700
  }, "64%"), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 423,
    x2: 332,
    y2: 423,
    stroke: "#E2EAF5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 468,
    fill: "#07172F",
    fontSize: 17,
    fontWeight: 650
  }, "5"), /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 457,
    r: 22,
    fill: "#DCE5F2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 103,
    y: 463,
    fill: "#24344D",
    fontSize: 15,
    textAnchor: "middle",
    fontWeight: 700
  }, "IJ"), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 445,
    width: 74,
    height: 8,
    rx: 4,
    fill: "#C9D5E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 462,
    width: 40,
    height: 7,
    rx: 3.5,
    fill: "#DEE6F1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 322,
    y: 464,
    fill: "#07172F",
    fontSize: 20,
    textAnchor: "end",
    fontWeight: 700
  }, "56%"), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 492,
    width: 218,
    height: 33,
    rx: 16.5,
    fill: "#FFFFFF",
    stroke: "#C9D8EC"
  }), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 513,
    fill: "#34435B",
    fontSize: 13,
    textAnchor: "middle"
  }, "View full rankings"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    stroke: "#BBD8FF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 272,
    r: 172
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 272,
    r: 145
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 272,
    r: 119
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430,
    y1: 272,
    x2: 839,
    y2: 272
  }), /*#__PURE__*/React.createElement("line", {
    x1: 635,
    y1: 99,
    x2: 635,
    y2: 448
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 272,
    r: 112,
    fill: "url(#lensGlow)",
    stroke: "url(#lensStroke)",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 272,
    r: 98,
    stroke: "#FFFFFF",
    strokeWidth: 8,
    strokeOpacity: 0.85
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 591,
    y: 101,
    width: 88,
    height: 31,
    rx: 8,
    fill: "#FF2775"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 635,
    y: 122,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    textAnchor: "middle",
    fontWeight: 700
  }, "Top match")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 214,
    r: 29,
    fill: "#087CFF"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 635,
    y: 222,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 19,
    textAnchor: "middle",
    fontWeight: 700
  }, "AB")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 635,
    y: 264,
    fill: "#40516B",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    textAnchor: "middle"
  }, "Suitability score")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 635,
    y: 318,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 52,
    textAnchor: "middle",
    fontWeight: 800
  }, "92%")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 487,
    cy: 437,
    r: 26,
    fill: "#F3F8FF",
    stroke: "#D7E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 426L482 437L492 448",
    stroke: "#087CFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 487,
    y: 481,
    fill: "#07172F",
    fontSize: 13,
    fontWeight: 700
  }, "Technical"), /*#__PURE__*/React.createElement("text", {
    x: 487,
    y: 498,
    fill: "#07172F",
    fontSize: 13,
    fontWeight: 700
  }, "competency"), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 511,
    width: 84,
    height: 7,
    rx: 3.5,
    fill: "#E4ECF6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 511,
    width: 77,
    height: 7,
    rx: 3.5,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 487,
    y: 543,
    fill: "#087CFF",
    fontSize: 18,
    fontWeight: 800
  }, "94%"), /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 437,
    r: 26,
    fill: "#FFF5F9",
    stroke: "#FFD8E6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 430,
    r: 6,
    stroke: "#FF2775",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625 447C626 438 644 438 645 447",
    stroke: "#FF2775",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 635,
    y: 481,
    fill: "#07172F",
    fontSize: 13,
    fontWeight: 700
  }, "Workplace"), /*#__PURE__*/React.createElement("text", {
    x: 635,
    y: 498,
    fill: "#07172F",
    fontSize: 13,
    fontWeight: 700
  }, "awareness"), /*#__PURE__*/React.createElement("rect", {
    x: 593,
    y: 511,
    width: 84,
    height: 7,
    rx: 3.5,
    fill: "#F5DCE7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593,
    y: 511,
    width: 73,
    height: 7,
    rx: 3.5,
    fill: "#FF2775"
  }), /*#__PURE__*/React.createElement("text", {
    x: 635,
    y: 543,
    fill: "#FF2775",
    fontSize: 18,
    fontWeight: 800
  }, "89%"), /*#__PURE__*/React.createElement("circle", {
    cx: 783,
    cy: 437,
    r: 26,
    fill: "#F3F8FF",
    stroke: "#D7E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783 424L792 428V437C792 444 788 449 783 452C778 449 774 444 774 437V428L783 424Z",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 783,
    y: 481,
    fill: "#07172F",
    fontSize: 13,
    fontWeight: 700
  }, "Profile"), /*#__PURE__*/React.createElement("text", {
    x: 783,
    y: 498,
    fill: "#07172F",
    fontSize: 13,
    fontWeight: 700
  }, "validity"), /*#__PURE__*/React.createElement("rect", {
    x: 741,
    y: 511,
    width: 84,
    height: 7,
    rx: 3.5,
    fill: "#E4ECF6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 741,
    y: 511,
    width: 76,
    height: 7,
    rx: 3.5,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 783,
    y: 543,
    fill: "#087CFF",
    fontSize: 18,
    fontWeight: 800
  }, "93%"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 568,
    width: 844,
    height: 54,
    rx: 14,
    fill: "#F6F9FE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 595,
    r: 21,
    fill: "#EDF5FF",
    stroke: "#D7E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 582L70 586V595C70 601 67 605 62 608C57 605 54 601 54 595V586L62 582Z",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 593,
    fill: "#55667F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13
  }, "Evidence-based ranking. Human decision.")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 611,
    fill: "#55667F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13
  }, "HR teams retain responsibility for decisions.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzMatchDashboardDesktop);
export default __webpack_public_path__ + "static/media/talentlenz-match-dashboard-desktop.64de2bcdb27c757e16a1fa6da2226bac.svg";
export { ForwardRef as ReactComponent };